import fetch from "auth/FetchInterceptor";

const LiveStreamService = {};

const liveStreamPrefix = "/live-streams";

LiveStreamService.getLiveStreams = async ({ page = 1, limit = 10, status, training, instructor, group, q }) => {
  let query = `${liveStreamPrefix}?page=${page}&limit=${limit}`;
  
  if (status) query += `&status=${status}`;
  if (training) query += `&training=${training}`;
  if (instructor) query += `&instructor=${instructor}`;
  if (group) query += `&group=${group}`;
  if (q) query += `&q=${q}`;
  query += `&userRole=admin`; // Pass user role to backend for role-based filtering (can be dynamic based on logged-in user)

  return await fetch(query, {
    method: "GET",
  });
};

LiveStreamService.getLiveStream = async (id) =>
  await fetch(`${liveStreamPrefix}/${id}`, {
    method: "GET",
  });

LiveStreamService.createLiveStream = async (data) =>
  await fetch(`${liveStreamPrefix}`, {
    method: "POST",
    data,
  });

LiveStreamService.updateLiveStream = async (id, data) =>
  await fetch(`${liveStreamPrefix}/${id}`, {
    method: "PATCH",
    data,
  });

LiveStreamService.deleteLiveStream = async (id) =>
  await fetch(`${liveStreamPrefix}/${id}`, {
    method: "DELETE",
  });

LiveStreamService.getChatMessages = async (id, { page = 1, limit = 20 }) =>
  await fetch(`${liveStreamPrefix}/${id}/chat?page=${page}&limit=${limit}`, {
    method: "GET",
  });

LiveStreamService.addChatMessage = async (id, message) =>
  await fetch(`${liveStreamPrefix}/${id}/chat`, {
    method: "POST",
    data: { message },
  });

LiveStreamService.deleteChatMessage = async (id, messageId) =>
  await fetch(`${liveStreamPrefix}/${id}/chat/${messageId}`, {
    method: "DELETE",
  });

export default LiveStreamService;
